import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import imgOne from "../../../assets/homepage/events/tradeShowOne.png";
import imgTwo from "../../../assets/homepage/events/tradeShowTwo.png";
import imgThree from "../../../assets/homepage/events/tradeShowThree.png";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination"; 
import "../../../components/Home/Events/EventStyles.css";

// import required modules
import { FreeMode, Pagination } from "swiper/modules";
import {
  LgResponsiveTradeShowCalender,
  LgResponsiveTradeShowVenue,
} from "../../../assets/svg/allSvg";

const SwiperComponent = () => {
  return (
    <div>
      <div className="max-w-[1241px] m-auto mt-[35px] px-[16px] md:px-[24px] h-[220px] md:h-[254px] lg:h-auto lg:px-0 flex flex-col">
        <div className="text-[14px] md:text-[18px] lg:text-[20px] font-semibold leading-[30px] w-[200px] h-[30px] md:w-auto md:h-[24px] lg:w-[235px] lg:h-[30px] text-[#323232] select-none">
          Upcoming Tradeshows
          <hr className="bg-[#FF8100] w-[211px] md:w-[279px] h-[4px] rounded-full mt-[5px]" />
        </div>
        <div>
          <div className="w-[328px] md:w-full lg:h-[276px] bg-transparent lg:bg-white rounded-[10px] mt-[23px]">
            <Swiper
              className="mainSlideBox"
              slidesPerView={3}
              spaceBetween={30}
              freeMode={true}
              pagination={{
                clickable: true,
              }}
              modules={[FreeMode, Pagination]}
            >
              <SwiperSlide className="miniSlides">
                <button>
                  <div
                    className="flex border bg-white md:bg-white md:rounded-[12px]
                   md:w-[348px] md:h-[142px] lg:w-[402px] lg:h-[181px] md:p-[16px] md:items-start md:justify-between items-center lg:items-center lg:gap-x-[19px] lg:justify-start rounded-[10px] lg:rounded-[10px] w-[328px] h-[126px] gap-x-[15px] text-left"
                  >
                    <div>
                      <img
                        src={imgOne}
                        className="w-[98px] h-[98px] md:w-[67px] md:h-[67px] lg:w-[100px] lg:h-[100px]"
                        alt="tradeShowImg"
                      />
                    </div>
                    <div className="flex flex-col gap-y-3 md:h-[110px] md:justify-between">
                      <p className="text-black font-semibold text-[14px] md:font-semibold md:text-[16px] lg:text-[20px]">
                        Trade Show 1
                      </p>

                      <div className="flex gap-x-2 md:gap-x-[11px] items-center justify-center">
                        {LgResponsiveTradeShowCalender}

                        <p className="text-left text-black font-semibold text-[12px] md:font-semibold md:text-[14px] lg:text-[16px]">
                          28 Feb 2024 - 2 Mar 2024
                        </p>
                      </div>

                      <div className="flex gap-x-2 md:gap-x-[11px]">
                        {LgResponsiveTradeShowVenue}

                        <p className="text-left text-black font-semibold text-[12px] md:font-semibold md:text-[14px] lg:text-[16px]">
                          Bandra, Mumbai
                        </p>
                      </div>
                    </div>
                  </div>
                </button>
              </SwiperSlide>

              <SwiperSlide className="miniSlides">
                <button>
                  <div
                    className="flex border bg-white md:bg-white md:rounded-[12px]
                   md:w-[348px] md:h-[142px] lg:w-[402px] lg:h-[181px] md:p-[16px] md:items-start md:justify-between items-center lg:items-center lg:gap-x-[19px] lg:justify-start rounded-[10px] lg:rounded-[10px] w-[328px] h-[126px] gap-x-[15px] text-left"
                  >
                    <div>
                      <img
                        src={imgTwo}
                        className="w-[98px] h-[98px] md:w-[67px] md:h-[67px] lg:w-[100px] lg:h-[100px]"
                        alt="tradeShowImg"
                      />
                    </div>
                    <div className="flex flex-col gap-y-3 md:h-[110px] md:justify-between">
                      <p className="text-black font-semibold text-[14px] md:font-semibold md:text-[16px] lg:text-[20px]">
                        Trade Show 1
                      </p>

                      <div className="flex gap-x-2 md:gap-x-[11px] items-center justify-center">
                        {LgResponsiveTradeShowCalender}

                        <p className="text-left text-black font-semibold text-[12px] md:font-semibold md:text-[14px] lg:text-[16px]">
                          28 Feb 2024 - 2 Mar 2024
                        </p>
                      </div>

                      <div className="flex gap-x-2 md:gap-x-[11px]">
                        {LgResponsiveTradeShowVenue}

                        <p className="text-left text-black font-semibold text-[12px] md:font-semibold md:text-[14px] lg:text-[16px]">
                          Bandra, Mumbai
                        </p>
                      </div>
                    </div>
                  </div>
                </button>
              </SwiperSlide>

              <SwiperSlide className="miniSlides">
                <button>
                  <div
                    className="flex border bg-white md:bg-white md:rounded-[12px]
                   md:w-[348px] md:h-[142px] lg:w-[402px] lg:h-[181px] md:p-[16px] md:items-start md:justify-between items-center lg:items-center lg:gap-x-[19px] lg:justify-start rounded-[10px] lg:rounded-[10px] w-[328px] h-[126px] gap-x-[15px] text-left"
                  >
                    <div>
                      <img
                        src={imgThree}
                        className="w-[98px] h-[98px] md:w-[67px] md:h-[67px] lg:w-[100px] lg:h-[100px]"
                        alt="tradeShowImg"
                      />
                    </div>
                    <div className="flex flex-col gap-y-3 md:h-[110px] md:justify-between">
                      <p className="text-black font-semibold text-[14px] md:font-semibold md:text-[16px] lg:text-[20px]">
                        Trade Show 1
                      </p>

                      <div className="flex gap-x-2 md:gap-x-[11px] items-center justify-center">
                        {LgResponsiveTradeShowCalender}

                        <p className="text-left text-black font-semibold text-[12px] md:font-semibold md:text-[14px] lg:text-[16px]">
                          28 Feb 2024 - 2 Mar 2024
                        </p>
                      </div>

                      <div className="flex gap-x-2 md:gap-x-[11px]">
                        {LgResponsiveTradeShowVenue}

                        <p className="text-left text-black font-semibold text-[12px] md:font-semibold md:text-[14px] lg:text-[16px]">
                          Bandra, Mumbai
                        </p>
                      </div>
                    </div>
                  </div>
                </button>
              </SwiperSlide>

              <SwiperSlide className="miniSlides">
                <button>
                  <div
                    className="flex border bg-white md:bg-white md:rounded-[12px]
                   md:w-[348px] md:h-[142px] lg:w-[402px] lg:h-[181px] md:p-[16px] md:items-start md:justify-between items-center lg:items-center lg:gap-x-[19px] lg:justify-start rounded-[10px] lg:rounded-[10px] w-[328px] h-[126px] gap-x-[15px] text-left"
                  >
                    <div>
                      <img
                        src={imgOne}
                        className="w-[98px] h-[98px] md:w-[67px] md:h-[67px] lg:w-[100px] lg:h-[100px]"
                        alt="tradeShowImg"
                      />
                    </div>
                    <div className="flex flex-col gap-y-3 md:h-[110px] md:justify-between">
                      <p className="text-black font-semibold text-[14px] md:font-semibold md:text-[16px] lg:text-[20px]">
                        Trade Show 1
                      </p>

                      <div className="flex gap-x-2 md:gap-x-[11px] items-center justify-center">
                        {LgResponsiveTradeShowCalender}

                        <p className="text-left text-black font-semibold text-[12px] md:font-semibold md:text-[14px] lg:text-[16px]">
                          28 Feb 2024 - 2 Mar 2024
                        </p>
                      </div>

                      <div className="flex gap-x-2 md:gap-x-[11px]">
                        {LgResponsiveTradeShowVenue}

                        <p className="text-left text-black font-semibold text-[12px] md:font-semibold md:text-[14px] lg:text-[16px]">
                          Bandra, Mumbai
                        </p>
                      </div>
                    </div>
                  </div>
                </button>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwiperComponent;
